"use client";

import {
  FaInstagram,
  FaFacebookF,
  FaLinkedinIn,
  FaYoutube,
} from "react-icons/fa";

const socials = [
  {
    label: "Instagram",
    href: "https://www.instagram.com/fornecedor_net/",
    Icon: FaInstagram,
    color:
      "bg-gradient-to-br from-purple-600 via-pink-500 to-orange-400 text-white",
  },
  {
    label: "Facebook",
    href: "https://www.facebook.com/fornecedor.net",
    Icon: FaFacebookF,
    color: "bg-[#1877F2] text-white",
  },
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/company/fonecedor-net-platform",
    Icon: FaLinkedinIn,
    color: "bg-[#0A66C2] text-white",
  },
  {
    label: "YouTube",
    href: "https://www.youtube.com/@Fornecedor_Net",
    Icon: FaYoutube,
    color: "bg-[#FF0033] text-white",
  },
];

function SocialLinks() {
  return (
    <>
      {socials.map(({ label, href, Icon, color }) => (
        <a
          key={label}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`Fornecedor.Net no ${label}`}
          title={label}
          className={`flex h-10 w-10 items-center justify-center rounded-lg shadow-sm transition-transform duration-200 hover:scale-110 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 ${color}`}
        >
          <Icon size={17} aria-hidden="true" />
        </a>
      ))}
    </>
  );
}

export default function FloatingSocials() {
  return (
    <>
      {/* Computador */}
      <aside
        aria-label="Redes sociais do Fornecedor.Net"
        className="fixed right-3 top-1/2 z-30 hidden -translate-y-1/2 flex-col gap-2 rounded-xl bg-white p-2 shadow-lg ring-1 ring-slate-200 md:flex"
      >
        <SocialLinks />
      </aside>

      {/* Celular */}
      <details className="group fixed right-2 top-1/2 z-30 -translate-y-1/2 rounded-xl bg-white p-1.5 shadow-lg ring-1 ring-slate-200 md:hidden">
        <summary
          aria-label="Abrir ou fechar redes sociais"
          className="flex h-10 w-10 cursor-pointer list-none items-center justify-center rounded-lg bg-[#2563eb] text-xl font-bold text-white [&::-webkit-details-marker]:hidden"
        >
          <span aria-hidden="true" className="group-open:hidden">
            ‹
          </span>
          <span aria-hidden="true" className="hidden group-open:inline">
            ×
          </span>
        </summary>

        <nav
          aria-label="Redes sociais do Fornecedor.Net"
          className="mt-2 flex flex-col gap-2 border-t border-slate-200 pt-2"
        >
          <SocialLinks />
        </nav>
      </details>
    </>
  );
}
